import { useState } from 'react'

import ModalForm from '@/gf/components/ModalForm'
import PhoneInput from '@/gf/components/PhoneInput'
import TextField from '@/gf/components/TextField'
import useMsgs from '@/gf/hooks/useMsgs'
import useAddUserToPlatform from '../hooks/useAddUserToPlatform'

interface IProps {
  open
  onClose
}

const AddPlatformUserModal: React.FC<IProps> = ({ open, onClose }) => {
  const [_msgs, Msgr] = useMsgs()
  const [name, setName] = useState<string>('')
  const [email, setEmail] = useState<string>('')
  const [phoneNumber, setPhoneNumber] = useState<string>('')
  const addUserToPlatform = useAddUserToPlatform()

  const submitCustomerShim = (e) => {
    e.preventDefault()
    Msgr.clear()

    if (name && phoneNumber && email) {
      addUserToPlatform({ name, email, phoneNumber })
        .then((_result) => window.location.reload())
        .catch((_error) => {
          Msgr.add('Whoops, something went wrong. Please contact support.', 'negative')
        })
    }
  }

  return (
    <ModalForm open={open} onClose={onClose} title="Add User" onSubmit={submitCustomerShim}>
      <div className="flex flex-col gap-4 py-6">
        <TextField
          label="Full Name"
          required
          value={name}
          onChange={(e) => setName(e.target.value)}
          noErrorText
        />
        <PhoneInput
          label="Phone Number"
          required
          value={phoneNumber}
          onChange={(newPhoneNumber) => setPhoneNumber(newPhoneNumber)}
        />
        <TextField
          label="Email Address"
          required
          type="email"
          pattern="^[^ ]+@[^ ]+\.[a-z]{2,6}$"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          noErrorText
        />
      </div>
    </ModalForm>
  )
}

export default AddPlatformUserModal
